import React from 'react';
import {Avatar, Tooltip} from '@mui/material';
import EditCloneDeleteMenu from "../Menus/EditCloneDeleteMenu";
import {Check} from "@mui/icons-material";
import Box from "@mui/material/Box";
import {blue} from "@mui/material/colors";
import {changeContract} from "../Contract/contractSlice";
import {changeDataPoint} from "./dataPointSlice";


export const DataPointGridColumns = ({ hideActions, onEdit, onClone, onDelete, handleMousedRow,
                                         handleValues, handleXrefs, handleUses,handleExpressions, handleSectionFilter, handleValueFilter }) => [


    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (dataPoints) => (
            <div
                onMouseOver={()=>         handleMousedRow(dataPoints.row)
                }>
            <Tooltip title={`Click to see actions for record ${dataPoints.row.id}`}>

                <EditCloneDeleteMenu
                    onEdit={() => onEdit(dataPoints.row)}
                    onClone={() => onClone(dataPoints.row)}
                    onDelete={() => onDelete(dataPoints.row)}
                />
            </Tooltip>
            </div>
        )
    },
    {    field: 'id',
        headerName: 'ID',
        description: '',
        sortable: true,
        width: 60,
        hide: false,
    },
    {
        field: 'mcode',
        headerName: 'Code',
        description: '',
        sortable: true,
        editable: true,
        hide: true,
        // editable: true,
        width: 200,
    },
    {
        field: 'name',
        headerName: 'Name',
        description: '',
        sortable: false,
        editable: true,
        width: 400,
        renderCell: (dataPoints) => {
            return (
                <Tooltip title={'Code: ' + dataPoints.row.mcode}>
                <p onClick= {() => handleValues(dataPoints.row.id, dataPoints.row.mcode, dataPoints.row.name, dataPoints.row.description, dataPoints.row)}
                   style={{cursor:'pointer'}}>
                    {dataPoints.row.name} </p>
                    </Tooltip>
            );
        }

    },
    {
        field: 'description',
        headerName: 'Description',
        description: '',
        sortable: false,
        editable: true,
        filterable: false,
        width: 500,
        renderCell: (dataPoints) => {
            return (
                <p onClick= {() => handleValues(dataPoints.row.id, dataPoints.row.mcode, dataPoints.row.name, dataPoints.row.description, dataPoints.row)}
                   style={{cursor:'pointer'}}>
                    {dataPoints.row.description} </p>
            );
        }
    },
    {
        field: 'dataType',
        headerName: 'Data Type',
        description: '',
        sortable: true,
        editable: true,
        hide: false,
        width: 120,
    },
    {
        field:  'allowMany',
        headerName: 'Allow Many',
        renderCell: (dataPoints) =>
        {
            if(dataPoints.row.allowMany === true ){
                return (
                    <Tooltip title={"Data Point allowed multiple times on a contract."}>
                        <Check/>
                    </Tooltip>)}

            if(dataPoints.row.allowMany === false ){
                return (
                    <p/>
                )}
        },
        description: '',
        sortable: false,
        width: 100,
    },
    {
        field: 'piiClassification',
        headerName: 'PII Classification',
        description: '',
        sortable: true,
        editable: true,
        hide: true,
        width: 220,
    },

    {
        field: 'dpvCount',
        headerName: 'Values',
        headerAlign: 'center',
        width: 100,
        renderCell: (dataPoints) => {
            const count = dataPoints.row.dpvCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Data Point has a list of values.  Click to see."}
                             onClick= {() => handleValues(dataPoints.row.id, dataPoints.row.mcode, dataPoints.row.name, dataPoints.row.description, dataPoints.row)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            // bgcolor:  deepOrange[500]
                            bgcolor: blue[500]
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },

    {
        field:  'dpxCount',
        headerName: 'Attributes',
        headerAlign: 'center',
        width: 100,
        renderCell: (dataPoints) => {
            const count = dataPoints.row.dpxCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Data Point has attributes.  Click to see."}
                             onClick= {() => handleXrefs(dataPoints.row.id, dataPoints.row.mcode, dataPoints.row.name, dataPoints.row.description, dataPoints.row)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            // bgcolor: deepPurple[500]
                            bgcolor: blue[500]
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },

    {
        field:  'cdpCount',
        headerName: 'Uses',
        headerAlign: 'center',
        width: 100,
        renderCell: (dataPoints) => {
            const count = dataPoints.row.cdpCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Data Point is used in contracts.  Click to see where."}
                             onClick= {() => handleUses(dataPoints.row.id, dataPoints.row.mcode, dataPoints.row.name, dataPoints.row.description, dataPoints.row)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: blue[500]
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },
    {
        field:  'expressionCount',
        headerName: 'Expressions',
        headerAlign: 'center',
        width: 100,
        renderCell: (dataPoints) => {
            const count = dataPoints.row.expressionCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Data Point is used in expressions.  Click to see where."}
                             onClick= {() => handleExpressions(dataPoints.row.id, dataPoints.row.mcode, dataPoints.row.name, dataPoints.row.description, dataPoints.row)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: blue[500]
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },
    {
        field:  'csfCount',
        headerName: 'Section Filters',
        headerAlign: 'center',
        width: 120,
        renderCell: (dataPoints) => {
            const count = dataPoints.row.csfCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Data Point is used as a section filter.  Click to see where."}
                             onClick= {() => handleSectionFilter(dataPoints.row.id, dataPoints.row.mcode, dataPoints.row.name, dataPoints.row.description, dataPoints.row)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: blue[500]
                            // bgcolor: red[500]
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },

    {
        field:  'cdpvfCount',
        headerName: 'Data Filters',
        headerAlign: 'center',
        width: 100,
        renderCell: (dataPoints) => {
            const count = dataPoints.row.cdpvfCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Data Point is used as a value filter.  Click to see where."}
                             onClick= {() => handleValueFilter(dataPoints.row.id, dataPoints.row.mcode, dataPoints.row.name, dataPoints.row.description, dataPoints.row)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: blue[500]
                            // bgcolor: lightGreen[500]
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },
];
